var version = {
    "name":      "dativery",
    "buildDateCode": "20260423-161714",
    "buildDate": "Thu Apr 23 2026 16:17:14 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260423-161714",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;